import { schema } from 'normalizr';
import { getOne, update, getList, GetOneOptions } from '../modules/fetch';
import { accountSchema, accountLinkedEntities } from '../Account';
import { currentAccountIdSelector } from '../modules/Auth';
import {
  organizationSchema,
  organizationLinkedEntities,
} from '../Organization/definitions';
import { CLIENT_ENTITY_NAME, Client } from './definition';
import { DeepPartial } from 'redux';

interface SetCurrentClientAction {
  type: 'CLIENT.SET_CURRENT';
  payload: string;
}

export type ClientActions = SetCurrentClientAction;

export const setCurrentClientId = (
  currentClient: string,
): SetCurrentClientAction => ({
  type: 'CLIENT.SET_CURRENT',
  payload: currentClient,
});

export const clientLinkedEntities = [
  CLIENT_ENTITY_NAME,
  ...accountLinkedEntities,
  ...organizationLinkedEntities,
];
export const clientSchema = new schema.Entity(CLIENT_ENTITY_NAME, {
  account: accountSchema,
  ownedOrganizations: [organizationSchema],
  organizations: [organizationSchema],
});

export const getOrganizationMembers = (id: string) =>
  getList({
    entity: CLIENT_ENTITY_NAME,
    schema: [clientSchema],
    path: `/organizations/${id}/members`,
  });

export const updateClient = (id: string, payload: DeepPartial<Client>) =>
  update<Client>({
    id,
    entity: CLIENT_ENTITY_NAME,
    schema: clientSchema,
    payload,
  });

export const refreshCurrentClient =
  (options?: Partial<GetOneOptions>) =>
  async (dispatch: Function, getState: () => any) => {
    const currentAccountId = currentAccountIdSelector(getState());
    if (!currentAccountId) {
      return Promise.reject();
    }

    const res = await dispatch(
      getOne({
        path: `/accounts/${currentAccountId}/clients`,
        entity: CLIENT_ENTITY_NAME,
        schema: clientSchema,
        ...options,
      }),
    );
    dispatch(setCurrentClientId(res.id));
    return;
  };
